"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoLocationUtils = void 0;
const TaskFunctionResponses_1 = require("@gt/common-utils/build/taskFunction/TaskFunctionResponses");
const TaskFunctionTypes_1 = require("@gt/common-utils/build/taskFunction/TaskFunctionTypes");
async function startWatchingPosition(onChange) {
    return new Promise((resolve) => {
        let resolved = false;
        const watchId = navigator.geolocation.watchPosition((position) => {
            const response = (0, TaskFunctionResponses_1.TFRSuccessPayload)({ watchId, position });
            if (!resolved) {
                resolve(response);
                resolved = true;
            }
            onChange(response);
            console.log(position);
        }, (error) => {
            const response = (0, TaskFunctionResponses_1.TFRFailure)(TaskFunctionTypes_1.ETaskFunctionEndId.ERROR, "Something went wrong getting user location", {
                error,
                watchId,
            });
            if (!resolved) {
                resolve(response);
                resolved = true;
            }
            onChange(response);
            console.log(error);
        });
    });
}
exports.GeoLocationUtils = {
    startWatchingPosition,
};
